import { SVGProps } from "react"

export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 1001 172"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3001_249211)">
      <g clipPath="url(#clip1_3001_249211)">
        <path
          d="M30.667 65.2364V100.701C30.667 107.573 35.0881 111.562 42.3925 111.562C45.9006 111.562 49.5528 110.697 52.1959 109.207V123.576C47.7748 125.642 41.7678 126.94 36.1934 126.94C20.5272 126.94 11.2525 118.146 11.2525 103.2V65.2364H0.776367V51.8769H12.5019V27.2725H31.8683V33.4236C31.8683 42.7944 24.8522 49.4261 13.0786 51.5886V51.8769H53.5414V65.2364H30.667Z"
          fill="white"
        />
        <path
          d="M119.233 52.7891L113.658 70.0891C110.727 68.4552 107.075 67.4461 103.375 67.4461C92.0815 67.4461 85.3537 76.6727 85.3537 92.2427V125.545H65.9873V51.9241H85.3537V82.2952H85.6421C85.6421 62.208 94.0037 50.4824 107.94 50.4824C112.169 50.4824 116.302 51.3474 119.233 52.8372V52.7891Z"
          fill="white"
        />
        <path
          d="M198.429 51.875V125.496H179.062V100.123H178.774C178.774 116.99 168.971 126.938 152.536 126.938C134.082 126.938 123.222 112.713 123.222 88.6856C123.222 64.6578 134.082 50.4333 152.536 50.4333C168.971 50.4333 178.774 60.3809 178.774 77.1042H179.062V51.875H198.429ZM180.12 88.6856C180.12 75.0378 173.248 65.667 161.474 65.667C149.7 65.667 142.876 74.317 142.876 88.6856C142.876 103.054 149.748 111.56 161.474 111.56C173.2 111.56 180.12 102.189 180.12 88.6856Z"
          fill="white"
        />
        <path
          d="M213.564 88.6856C213.564 64.6578 227.789 50.4333 251.528 50.4333C271.616 50.4333 284.687 61.0056 287.618 79.1706H268.54C266.041 70.6648 260.178 65.667 251.528 65.667C240.091 65.667 233.363 74.317 233.363 88.6856C233.363 103.054 240.091 111.56 251.528 111.56C260.611 111.56 266.618 106.274 268.828 97.1915H287.906C285.119 116.125 272.048 126.938 251.528 126.938C227.789 126.938 213.564 112.713 213.564 88.6856Z"
          fill="white"
        />
        <path
          d="M370.324 90.8962H316.646C317.367 104.4 323.855 112.281 334.235 112.281C343.317 112.281 349.612 107.283 351.535 99.2098H370.324C367.681 116.654 354.178 126.938 334.235 126.938C311.36 126.938 297.856 112.713 297.856 88.6856C297.856 64.6578 311.36 50.4333 334.235 50.4333C357.109 50.4333 370.324 64.5136 370.324 88.6856V90.8962ZM316.79 84.3126H351.39C350.237 72.0103 343.894 64.9461 334.235 64.9461C324.575 64.9461 318.088 71.9623 316.79 84.3126Z"
          fill="white"
        />
        <path
          d="M440.533 40.1501V51.8757H463.695V65.2351H441.542V125.497H422.175V65.2351H411.026V51.8757H439.764V51.5873C428.038 49.3768 421.166 42.7932 421.166 33.4223C421.166 19.342 431.882 11.1245 449.903 11.1245C456.199 11.1245 462.494 12.422 467.492 14.7767L464.993 29.2895C462.061 27.5115 458.409 26.5023 454.565 26.5023C445.338 26.5023 440.484 31.6443 440.484 40.1501H440.533Z"
          fill="#739987"
        />
        <path
          d="M468.692 88.6856C468.692 64.6578 483.061 50.4333 507.089 50.4333C531.117 50.4333 545.341 64.6578 545.341 88.6856C545.341 112.713 531.117 126.938 507.089 126.938C483.061 126.938 468.692 112.713 468.692 88.6856ZM525.734 88.6856C525.734 74.317 518.862 65.667 507.137 65.667C495.411 65.667 488.491 74.317 488.491 88.6856C488.491 103.054 495.363 111.56 507.137 111.56C518.911 111.56 525.734 103.054 525.734 88.6856Z"
          fill="#739987"
        />
        <path
          d="M613.726 52.7891L608.152 70.0891C605.22 68.4552 601.568 67.4461 597.868 67.4461C586.575 67.4461 579.847 76.6727 579.847 92.2427V125.545H560.48V51.9241H579.847V82.2952H580.135C580.135 62.208 588.497 50.4824 602.433 50.4824C606.662 50.4824 610.795 51.3474 613.726 52.8372V52.7891Z"
          fill="#739987"
        />
        <path
          d="M723.242 51.875V126.361C723.242 147.89 709.45 160.673 686.288 160.673C666.345 160.673 652.841 150.87 650.198 134.29L668.507 131.503C669.66 140.153 676.436 145.295 686.24 145.295C697.244 145.295 703.828 138.712 703.828 127.563V99.402H703.54C703.54 116.125 693.736 126.073 677.301 126.073C658.848 126.073 647.987 111.993 647.987 88.2531C647.987 64.5136 658.848 50.4333 677.301 50.4333C693.736 50.4333 703.54 60.3809 703.54 77.1042H703.828V51.875H723.194H723.242ZM704.933 88.2531C704.933 74.8937 698.061 65.667 686.336 65.667C674.61 65.667 667.738 74.1728 667.738 88.2531C667.738 102.333 674.61 110.695 686.336 110.695C698.061 110.695 704.933 101.613 704.933 88.2531Z"
          fill="white"
        />
        <path
          d="M738.384 88.6856C738.384 64.6578 752.752 50.4333 776.78 50.4333C800.808 50.4333 815.032 64.6578 815.032 88.6856C815.032 112.713 800.808 126.938 776.78 126.938C752.752 126.938 738.384 112.713 738.384 88.6856ZM795.426 88.6856C795.426 74.317 788.554 65.667 776.828 65.667C765.103 65.667 758.231 74.317 758.231 88.6856C758.231 103.054 765.103 111.56 776.828 111.56C788.554 111.56 795.426 103.054 795.426 88.6856Z"
          fill="white"
        />
        <path
          d="M795.426 88.6856C795.426 64.6578 809.794 50.4333 833.822 50.4333C857.85 50.4333 872.074 64.6578 872.074 88.6856C872.074 112.713 857.85 126.938 833.822 126.938C809.794 126.938 795.426 112.713 795.426 88.6856ZM852.468 88.6856C852.468 74.317 845.596 65.667 833.87 65.667C822.145 65.667 815.273 74.317 815.273 88.6856C815.273 103.054 822.145 111.56 833.87 111.56C845.596 111.56 852.468 103.054 852.468 88.6856Z"
          fill="#739987"
        />
        <path
          d="M958.765 12.615V125.498H939.398V100.124H939.11C939.11 116.992 929.307 126.939 912.872 126.939C894.418 126.939 883.558 112.715 883.558 88.687C883.558 64.6592 894.418 50.4348 912.872 50.4348C929.307 50.4348 939.11 60.3823 939.11 77.1056H939.398V12.615H958.765ZM940.455 88.7351C940.455 75.0873 933.584 65.7164 921.858 65.7164C910.132 65.7164 903.26 74.3665 903.26 88.7351C903.26 103.104 910.132 111.61 921.858 111.61C933.584 111.61 940.455 102.239 940.455 88.7351Z"
          fill="white"
        />
        <path
          d="M998.216 104.833V125.497H976.688V104.833H998.216Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3001_249211">
        <rect
          width="999.999"
          height="171.607"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
      <clipPath id="clip1_3001_249211">
        <rect
          width="997.442"
          height="149.549"
          fill="white"
          transform="translate(0.776367 11.1245)"
        />
      </clipPath>
    </defs>
  </svg>
)
